import { createSelector } from "@reduxjs/toolkit";

export const brandingCustomCssSelector = createSelector<[(state: LSStore.State) => LSCommon.BrandedJsModel | null], string | null>(state => state.branding.value || null, branding => branding?.customCss || null);
